import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import homeReducer from '../features/home/redux/reducer';
import commonReducer from '../features/common/redux/reducer';
import loginReducer from '../features/login/redux/reducer';
import registerReducer from '../features/register/redux/reducer';
import phaseReducer from '../features/phase/redux/reducer';
import memberReducer from '../features/member/redux/reducer';
import wbsReducer from '../features/wbs/redux/reducer';
import caReducer from '../features/ca/redux/reducer';
import costReducer from '../features/cost/redux/reducer';
import summaryReducer from '../features/summary/redux/reducer';
import unitReducer from '../features/unit/redux/reducer';
import currencyReducer from '../features/currency/redux/reducer';
import dcReducer from '../features/dc/redux/reducer';
import dailyReducer from '../features/daily/redux/reducer';
import fileuploadReducer from '../features/fileupload/redux/reducer';
import actualReducer from '../features/actual/redux/reducer';
import completionReducer from '../features/completion/redux/reducer';
import cirReducer from '../features/cir/redux/reducer';
import periodsReducer from '../features/periods/redux/reducer';
import profileReducer from '../features/profile/redux/reducer';
import statusReducer from '../features/status/redux/reducer';
import workplanReducer from '../features/workplan/redux/reducer';
import companyReducer from '../features/company/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage them.

const reducerMap = {
  router: routerReducer,
  home: homeReducer,
  common: commonReducer,
  login: loginReducer,
  register: registerReducer,
  phase: phaseReducer,
  member: memberReducer,
  wbs: wbsReducer,
  ca: caReducer,
  cost: costReducer,
  summary: summaryReducer,
  unit: unitReducer,
  currency: currencyReducer,
  dc: dcReducer,
  daily: dailyReducer,
  fileupload: fileuploadReducer,
  actual: actualReducer,
  completion: completionReducer,
  cir: cirReducer,
  periods: periodsReducer,
  status: statusReducer,
  profile: profileReducer,
  workplan: workplanReducer,
  company: companyReducer,

};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js